export default "__VITE_ASSET__CuQ5BaGz__"